import styled from 'styled-components';

import Btn from 'components/Button';
import Msg from 'components/Message';

export const Title = styled.h3`
  border-top: 1px solid var(--color-grey97);
  font-size: var(--font-size15);
  font-weight: var(--font-weight600);
  color: var(--color-grey6A);
  padding-top: 10px;
  margin: 10px 0 20px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
`;

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  gap: 8px;
`;

export const Button = styled(Btn)`
  width: 100%;
  height: 40px;
  padding: 0 6px;
  font-size: var(--font-size11);
  font-weight: var(--font-weight500);
  letter-spacing: 0.92px;
  color: var(--color-grey6A);
  word-break: break-word;
  text-align: center;
`;

export const Message = styled(Msg).attrs(() => ({
  type: 'error',
  form: 1,
  small: 1,
}))`
  text-align: right;
`;
